export default "__VITE_ASSET__BY1pG9KS__"